import { Grid, Typography } from '@material-ui/core';
import React from 'react';

import { fieldIsBlock, FieldsActionBR, FieldsNameBR } from '../../constants';
import formatHistoryInfo from '../formatters';
import { useStyles } from '../styles';

import type { ChangeLogHistoryItemValue } from '../../constants';

type HistoryDetailsItems = {
  field: string;
  change: ChangeLogHistoryItemValue;
};

function HistoryDetailsItems({ field, change }: HistoryDetailsItems) {
  const classes = useStyles();

  const fieldHasBooleanValue = typeof field === 'boolean';
  const haveOnlyTo = change.action === 'add';
  const showFrom = !fieldHasBooleanValue || !haveOnlyTo;
  const showTo = !fieldHasBooleanValue;

  return (
    <Grid item xs={12}>
      <div className={classes.itemWrapper}>
        <div className={classes.itemField}>
          <Typography variant='body1'>{FieldsNameBR[field]}</Typography>
        </div>
        <div className={classes.itemDetails} data-block={fieldIsBlock.includes(field)} key={field}>
          <div>
            <Typography className={classes.itemAction} variant='body1'>
              {FieldsActionBR[change.action]}
            </Typography>
          </div>
          {change?.status && (
            <div>
              <Typography variant='body1'>{change.status}</Typography>
            </div>
          )}
          {showFrom && (
            <div>
              <Typography className={classes.itemOld} variant='body1'>
                {formatHistoryInfo(field, change.from)}
              </Typography>
            </div>
          )}
          {showTo && (
            <div>
              <Typography className={classes.itemNew} variant='body1'>
                {formatHistoryInfo(field, change.to)}
              </Typography>
            </div>
          )}
        </div>
      </div>
    </Grid>
  );
}

export default HistoryDetailsItems;
